import {useNavigate} from 'react-router-dom';

export const useController = () => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('/');
  };

  return {
    onNavigate: handleNavigate,
  };
};
